import { set } from "date-fns";

const trimTime = (date: Date | number) =>
  set(date, {
    hours: 0,
    minutes: 0,
    seconds: 0,
    milliseconds: 0
  });

const toWallClock = (date: Date) =>
  Date.UTC(
    date.getFullYear(),
    date.getMonth(),
    date.getDate(),
    date.getHours(),
    date.getMinutes(),
    date.getSeconds(),
    date.getMilliseconds()
  );

const fromWallClock = (time: number) => {
  const wall = new Date(time);
  const date = new Date(0);
  date.setFullYear(
    wall.getUTCFullYear(),
    wall.getUTCMonth(),
    wall.getUTCDate()
  );
  date.setHours(
    wall.getUTCHours(),
    wall.getUTCMinutes(),
    wall.getUTCSeconds(),
    wall.getUTCMilliseconds()
  );
  return date;
};

// A date without time ("2026-10-23", as tasks have) is that day wherever the
// user is; new Date() would read it as UTC midnight and move it a day in some
// time zones
const parseDateOnly = (value: string | Date) => {
  const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(String(value));
  return match
    ? new Date(Number(match[1]), Number(match[2]) - 1, Number(match[3]))
    : new Date(value);
};

const shiftDateBy = (date: Date, from: Date, to: Date) =>
  fromWallClock(toWallClock(date) + toWallClock(to) - toWallClock(from));

const dateUtils = {
  trimTime,
  shiftDateBy,
  parseDateOnly
};

export { dateUtils as default, trimTime, shiftDateBy, parseDateOnly };
